
shadow.loader.init("");
nosco.trial.trial_form.start();